// extracted by mini-css-extract-plugin
module.exports = {"form":"reservationChannel_form__26rnx"};